import React from 'react';
import { Link } from 'react-router-dom';
import { track } from '../lib/analytics';

// Shared shell + typography for markdown-rendered pages (blog, compare, capabilities).
export const Shell = ({ children }) => (
  <div className="min-h-screen bg-white dark:bg-black text-gray-700 dark:text-gray-300">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <Link to="/" className="text-emerald-600 hover:text-emerald-700 dark:text-emerald-400 dark:hover:text-emerald-300 text-sm">
        ← emboscale.com
      </Link>
      {children}
    </div>
  </div>
);

export const articleClass = `mt-8 leading-relaxed
  [&_h1]:text-4xl [&_h1]:font-bold [&_h1]:tracking-tight [&_h1]:text-gray-900 dark:[&_h1]:text-white [&_h1]:mb-8 [&_h1]:leading-tight
  [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-gray-900 dark:[&_h2]:text-white [&_h2]:mt-12 [&_h2]:mb-4
  [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:text-gray-900 dark:[&_h3]:text-white [&_h3]:mt-8 [&_h3]:mb-3
  [&_p]:mb-5 [&_strong]:text-gray-900 dark:[&_strong]:text-white
  [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-3 [&_ol]:mb-5
  [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_ul]:mb-5
  [&_a]:text-emerald-600 dark:[&_a]:text-emerald-400 [&_em]:text-gray-800 dark:[&_em]:text-gray-200
  [&_blockquote]:border-l-2 [&_blockquote]:border-emerald-500 [&_blockquote]:pl-4 [&_blockquote]:mb-5
  [&_img]:w-full [&_img]:rounded-xl [&_img]:border [&_img]:border-black/10 dark:[&_img]:border-white/10 [&_img]:mt-2 [&_img]:mb-2
  [&_hr]:border-black/10 dark:[&_hr]:border-white/10 [&_hr]:my-10
  [&_table]:w-full [&_table]:text-sm [&_table]:border-collapse [&_table]:my-6 [&_table]:block [&_table]:overflow-x-auto
  [&_th]:text-left [&_th]:text-gray-900 dark:[&_th]:text-white [&_th]:font-semibold [&_th]:border-b [&_th]:border-black/20 dark:[&_th]:border-white/20 [&_th]:py-2 [&_th]:pr-4
  [&_td]:py-2 [&_td]:pr-4 [&_td]:border-b [&_td]:border-black/10 dark:[&_td]:border-white/10 [&_td]:align-top`;

// Closing call to action on every blog/content page: readers who finish an
// article are the warmest traffic the site gets — give them the next step.
export const DemoCta = () => (
  <aside className="mt-16 rounded-2xl border border-emerald-500/30 bg-emerald-500/5 p-6 sm:p-8">
    <div className="font-mono text-xs tracking-[0.25em] uppercase text-emerald-600 dark:text-emerald-400 mb-3">
      The Factory Agent
    </div>
    <p className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
      See your line planned, balanced, and robot-programmed from one prompt.
    </p>
    <p className="text-gray-600 dark:text-gray-400 mb-6">
      A 30-minute demo on your own use case — layout, line balance, shift schedule, verified robot programs.
    </p>
    <Link
      to="/#cta"
      onClick={() => track('Book demo click', { page: window.location.pathname })}
      className="inline-block rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-medium px-6 py-3 transition-colors duration-200"
    >
      Book a demo →
    </Link>
  </aside>
);
